import { sortByDate } from "@utils/sorters";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { isAfter, isBefore, parse } from "date-fns";
import { formatDate, formatTime } from "@utils/dates";

const endpoint:string = 'opportunities';

export function useGetAllOpportunities(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetOpportunity(id: number, params:any = {}) {
    // this will transform old job slot syntax (array of objects) into new syntax (array of IDs)
    const transform = (data) => {
        let jobs = data.jobs.map(job => {
            let available_time_slots = job.available_time_slots.map(slot => typeof slot === 'object' ? slot.id : slot);
            job.available_time_slots = available_time_slots;
            return job;
        });

        data.jobs = jobs;

        return data;
    }

    return useGetOne({queryKey: [endpoint, id], transform: transform, ...params});
}

export function useCreateOpportunity() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateOpportunity({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteOpportunity({id}) {
    return useDelete({queryKey: [endpoint, id]});
}


export function getSignupsForSlot(object, jobId, timeSlotId) {
    var signupsForSlot:any[] = [];
    if(!object.hasOwnProperty('sign_ups') || !object.sign_ups.length) {
        return signupsForSlot;
    }

    for(var $i = 0; $i < object.sign_ups.length; $i++) {
        var signUp = object.sign_ups[$i];

        if(signUp.opportunity_job_id == jobId && signUp.opportunity_time_slot_id == timeSlotId) {
            signupsForSlot.push(signUp);
        }
    }

    return signupsForSlot;
};


export function generateCompiledJobs($data) {
    if(!$data) {
        return null;
    }

    // fix times
    for(let $i=0; $i < $data.time_slots.length; $i++) {
        /*
        if (typeof $data.time_slots[$i].start_time == 'string') {
            $data.time_slots[$i].start_time = $data.time_slots[$i].start_time ? moment(moment().format("YYYY-MM-DD") + " " + $data.time_slots[$i].start_time) : null;
        }
        if (typeof $data.time_slots[$i].end_time == 'string') {
            $data.time_slots[$i].end_time = $data.time_slots[$i].end_time ? moment(moment().format("YYYY-MM-DD") + " " + $data.time_slots[$i].end_time) : null;
        }
        */
    }

    // flatten jobs & time slots
    let combinedJobs = [];
    for(let $i = 0; $i < $data.jobs.length; $i++) {
        let job = $data.jobs[$i];

        // handle no jobs
        if(!job.available_time_slots.length) {
            combinedJobs.push({
                id: job.id,
                opportunity_id: job.opportunity_id,
                slot_id: null,
                name: job.name,
                description: job.description,
                quantity: job.quantity,
                available_slots: 0,
                time_slot: 'N/A',
                slots: [],
            });
        }

        for(let $k = 0; $k < job.available_time_slots.length; $k++) {
            let timeSlot = job.available_time_slots[$k];

            // old opporunities had this baked in, new opportunities get the info dynamically
            // todo: figure out how to save the data (requires getting edit objectAsValue working)
            if(typeof timeSlot === 'number') {
                timeSlot = $data.time_slots.find(slot => slot.id === timeSlot);

                if(!timeSlot) {
                    continue;
                }

                let timeSlotLabel = formatDate(timeSlot.date);//timeSlot.date.format('L') + ' ';
                    if(!timeSlot.start_time) {
                        timeSlotLabel += ' (All Day)';
                    } else {
                        timeSlotLabel += ` ${formatTime(timeSlot.start_time)} - ${formatTime(timeSlot.end_time)}`;
                    }

                timeSlot = {
                    id: timeSlot.id,
                    date: timeSlot.date,
                    formattedDate: formatDate(timeSlot.date),
                    label: timeSlotLabel,
                };
            }

            let totalSlots = job.quantity;
            let takenSlots = getSignupsForSlot($data, job.id, timeSlot.id);
            let slots = [];

            for(var $l = 0; $l < totalSlots; $l++) {
                var signup = null;
                if(takenSlots.length > 0) {
                    signup = takenSlots.shift();
                }

                slots.push({
                    name: 'Slot #'+($l+1),
                    signup: signup,
                });
            }

            combinedJobs.push({
                id: job.id,
                opportunity_id: job.opportunity_id,
                slot_id: timeSlot.id,
                name: job.name,
                description: job.description,
                quantity: job.quantity,
                available_slots: (job.quantity - getSignupsForSlot($data, job.id, timeSlot.id).length),
                time_slot: timeSlot.label,//.replace(/(\d)([ap])/, '$1 $2'),
                slots: slots,
            });
        }
    }

    // sort jobs
    combinedJobs.sort(function(a, b) {
        if(a.slot_id === null) return 1; // sort null to bottom

        //07/15/2020 08:00am - 09:00am
        const now = new Date();
        const formatToParse = "MM/dd/yyyy hh:mmaaaaa'm'";
        ///*.replace(/(\d)([ap])/, '$1 $2')*/
        const aTimeSlot = parse(a.time_slot.split(' - ')[0], formatToParse, now);
        const bTimeSlot = parse(b.time_slot.split(' - ')[0], formatToParse, now);

        if(isAfter(aTimeSlot, bTimeSlot)) return 1;
        if(isBefore(aTimeSlot, bTimeSlot)) return -1;
        return 0;
    });

    return combinedJobs;
}
